/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "httpapivillalogisticboard",
            "endpoint": "https://by0uq1k66l.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://o3ixiwo55vbxjgphoutp5anxdy.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-vuclxxgsnvcedesdvdh6rbbcqi"
};


export default awsmobile;
